import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";

import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";
import useCostType from "./hooks/useCostType";

const CostType = () => {
  const costTypeData = useCostType();

  return (
    <div class="container container-fluid">
      <div className="header-section">
        <h1>
          {costTypeData.screen_title} -{" "}
          <span className="heading-cod">{costTypeData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={costTypeData.formFields}
        dropdownValues={costTypeData.dropdownValues}
        paramsData={costTypeData.paramsData}
        updataParamData={costTypeData.updateParamData}
      />
      <ButtonsSection ctaButtons={costTypeData.ctaButtons} />
      <DisplayTable
        data={costTypeData.data}
        parmKey={costTypeData.parmKey}
        menuOptions={costTypeData.menuOptions}
        tableHeaders={costTypeData.columnDef}
        setRowData={costTypeData.setRowData}
        selectedPriceSchedules={costTypeData.selectedRows}
        setSelectedPriceSchedules={costTypeData.setSelectedRows}
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={costTypeData.first}
          rows={costTypeData.rows}
          totalRecords={costTypeData.totalRecords}
          currentPage={costTypeData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={costTypeData.onPageChange}
        />
      </div>
      {costTypeData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={costTypeData.isConfirmationModalOpen}
          onRequestClose={costTypeData.closeConfirmationModal}
          onBack={costTypeData.closeConfirmationModal}
          onSave={costTypeData.deleteCostType}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={costTypeData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default CostType;
